module.exports = __webpack_public_path__ + "img/reassignvr.e2530dce.svg";